import React from 'react';
import { Row } from 'react-table';

import PartyPill from '../../../display/components/PartyPill';
import sortByName from './sort-by-name';
import isVacant from './is-vacant';

import { ITableRow } from '../types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function createPartyColumn() {
  return {
    accessor: 'party',

    Cell: ({
      value: party,
      row: {
        values: { name },
      },
    }: {
      value: string;
      row: Row<ITableRow>;
    }): JSX.Element | null => {
      if (isVacant(name)) {
        return null;
      }
      return <PartyPill party={party} />;
    },

    Header: 'Party',

    sortType: (
      firstRow: Row<ITableRow>,
      secondRow: Row<ITableRow>,
      colId: string,
      isDesc: boolean
    ): number => {
      const firstParty = firstRow.original.party;
      const secondParty = secondRow.original.party;

      if (firstParty > secondParty) {
        return 1;
      }
      if (firstParty < secondParty) {
        return -1;
      }
      if (isDesc) {
        return sortByName(secondRow, firstRow);
      }
      return sortByName(firstRow, secondRow);
    },
  };
}
